import { render } from "./BackgroundBigStars.vue?vue&type=template&id=1873a2e8&scoped=true"
import script from "./BackgroundBigStars.vue?vue&type=script&lang=js"
export * from "./BackgroundBigStars.vue?vue&type=script&lang=js"

import "./BackgroundBigStars.vue?vue&type=style&index=0&id=1873a2e8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1873a2e8"]])

export default __exports__